export const PUSH_NOTIFICATION_TABLE_HEADERS = [
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
  { label: '', colspan: 1 },
];

export const PUSH_NOTIFICATION_TABLE_SUB_HEADERS = [
  { label: 'DATE / TIME', key: 'dateTime', noTopBorder: true },
  { label: 'TITLE', key: 'title', noTopBorder: true },
  { label: 'MESSAGE', key: 'message', noTopBorder: true },
  { label: 'COVER IMAGE', key: 'coverImage', noTopBorder: true },
  { label: 'FEATURE IMAGE', key: 'featureImage', noTopBorder: true },
  { label: 'LOGS', key: 'totalCount', noTopBorder: true },
  { label: 'VIEWS', key: 'viewCount', noTopBorder: true },
  { label: 'ACTION', key: 'status', noTopBorder: true },
];
